import { z } from 'zod';
import { DeviceTypeSchema } from './device.js';
import { SensorTypeSchema } from './sensor.js';
export const SensorSpecSchema = z.object({
    sensorType: SensorTypeSchema,
    displayName: z.string().min(1).max(60),
    unit: z.string().max(20),
    dataType: z.enum(['number', 'boolean', 'string']),
    minValue: z.number().optional(),
    maxValue: z.number().optional(),
});
export const ActuatorSpecSchema = z.object({
    channel: z.string().min(1).max(20),
    displayName: z.string().min(1).max(60),
    type: z.enum(['relay', 'pwm']),
});
export const DeviceModelSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(100),
    code: z.string().regex(/^[A-Z0-9]{2,6}$/, '모델 코드는 대문자 영숫자 2~6자여야 합니다'),
    deviceType: DeviceTypeSchema,
    description: z.string().max(500).optional(),
    tagline: z.string().max(120).optional(),
    sensors: z.array(SensorSpecSchema),
    actuators: z.array(ActuatorSpecSchema).optional(),
    growthEnabled: z.boolean(),
    growthFields: z.array(z.string()),
    comm: z.string().max(60).optional(),
    battery: z.string().max(60).optional(),
    interval: z.string().max(60).optional(),
    firmware: z.string().max(60).optional(),
    isBuiltin: z.boolean(),
    createdAt: z.string().datetime(),
});
export const CreateDeviceModelSchema = DeviceModelSchema.omit({
    id: true,
    createdAt: true,
    isBuiltin: true,
});
export const UpdateDeviceModelSchema = CreateDeviceModelSchema.partial();
// admin localStorage → 서버 임포트 페이로드. oldId(이전 localStorage uuid)로
// 기존 장비의 device_model_id 참조를 새 code로 remap하기 위해 함께 전달한다.
export const ImportDeviceModelSchema = CreateDeviceModelSchema.extend({
    oldId: z.string().min(1),
});
export const ImportDeviceModelsSchema = z.object({
    models: z.array(ImportDeviceModelSchema).max(200),
});
//# sourceMappingURL=device-model.js.map